import {ConfirmPopup} from "primereact/confirmpopup";
import {Tooltip} from "primereact/tooltip";
import {useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

export default function ResetIcon({onValueChange, parameter}) {
    const ref = useRef(null);

    const [mounted, setMounted] = useState(false);
    const {t} = useTranslation();
    const [resetConfirmVisible, setResetConfirmVisible] = useState(false);

    useEffect(() => {
        if (ref.current && !mounted) {
            setMounted(true); // Trigger a re-render when ref is assigned
        }
    }, [mounted]);

    const onConfirmReset = () => {
        onValueChange(null, null);
        setResetConfirmVisible(false);
    };

    return (
        <>
            <Tooltip target={ref.current} className="custom-tooltip" />
            <ConfirmPopup
                target={ref.current}
                visible={resetConfirmVisible}
                onHide={() => setResetConfirmVisible(false)}
                icon="pi pi-exclamation-triangle"
                accept={onConfirmReset}
                message={t("object.inputResetConfirm")}
                acceptClassName="p-button-danger"
                acceptLabel={t("object.inputResetConfirmYes")}
                rejectLabel={t("object.inputResetConfirmNo")}
            />
            <i
                ref={ref}
                className="pi pi-ban tooltip-icon text-blue-500 cursor-pointer"
                data-pr-tooltip={t("object.inputResetTooltip")}
                data-pr-position="top"
                test-key={`reset-icon-${parameter}`}
                onClick={() => setResetConfirmVisible(true)}
            />
        </>
    );
}
